var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.user_details") } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _vm.activateSpinner
                ? _c("spinner")
                : _vm.User
                ? [
                    _c("div", { staticClass: "title-label-blue w-100" }, [
                      _vm._v(_vm._s(_vm.$t("administration.user_info"))),
                    ]),
                    _vm._v(" "),
                    _c("table", { staticClass: "table" }, [
                      _c("tbody", [
                        _c("tr", [
                          _c("th", { staticClass: "text-center w-50" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("administration.identifier")) +
                                "\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.User.Login) +
                                "\n                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.User.Name
                          ? _c("tr", [
                              _c("th", { staticClass: "text-center w-50" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("administration.user_name")) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.User.Name) +
                                    "\n                "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { staticClass: "text-center w-50" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("administration.active")) +
                                "\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center w-50" }, [
                            _vm.User.Active == 0
                              ? _c("i", {
                                  staticClass:
                                    "fa-duotone fa-xmark btn btn-icon btn-icon-red p-0 min-h-auto",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.User.Active == 2
                              ? _c("i", {
                                  staticClass:
                                    "fa-duotone fa-check btn btn-icon btn-icon-green p-0 min-h-auto",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.User.Active == 1
                              ? _c("i", {
                                  staticClass:
                                    "fa-duotone fa-warning btn btn-icon btn-icon-orange p-0 min-h-auto",
                                })
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "title-label-blue w-100" }, [
                      _vm._v(_vm._s(_vm.$t("administration.user_auth"))),
                    ]),
                    _vm._v(" "),
                    _vm.User.Rights && _vm.User.Rights.length
                      ? _c("table", { staticClass: "table table-striped" }, [
                          _c(
                            "tbody",
                            [
                              _c("tr", [
                                _c("th", { staticClass: "text-center w-50" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("administration.company_name")
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "text-center w-50" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("administration.profile")) +
                                      "\n              "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.User.Rights, function (right) {
                                return _c(
                                  "tr",
                                  {
                                    key:
                                      right.IdAccount +
                                      "-" +
                                      right.IdRightProfile,
                                  },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "text-center w-50" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(right.AccountName) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-center w-50" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.hasProfileTrad(
                                                right.RightsProfileName
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "bottomActions" },
        [
          _vm.canUserEdit
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("administration.edit"),
                  icon: "fa-light fa-pencil",
                  variant: "primary",
                },
                on: {
                  click: function ($event) {
                    return _vm.activateEdit(_vm.User.IdUser)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.canUserDelete
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("rights.delete"),
                  icon: "fa-light fa-trash",
                  variant: "primary",
                },
                on: {
                  click: function ($event) {
                    return _vm.activateDelete(_vm.User.IdUser)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }